var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"footer":""}},[_c('v-main',[_c('router-view')],1),_c('notifications',{attrs:{"group":"global","position":"top center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }